import { Address, CompanyResponseModel } from 'src/business/services/client.generated';
import { Cookie } from './cookies';


export namespace MarketSegment {
    export type Type = 'B2C' | 'B2B';

    const cookieStore = Cookie;

    export function isCompany(): boolean {
        return ((cookieStore.get('PriceListKey')) ?? '') == 'B2B';
    }
    export function isPrivateCustomer(): boolean {
        return ((cookieStore.get('PriceListKey')) ?? '') == 'B2C';
    }
    export function isPublicInstituion(): boolean {
        return false;
    }
    export function mapAddress(address: CompanyResponseModel): Address {
        return {
            organizationName: address.companyName,
            line1: address.address,
            postalCode: address.zipCode,
            city: address.city,
            country: address.countryCode,
        }
    }
    export function isSelected(): boolean {
        return (cookieStore.get('PriceListKey')) != null;
    }
    export function setSegment(segment: Type): void {
        cookieStore.set('PriceListKey', segment);
        setTimeout(() => window.location.href = window.location.href, 100);
        return null;
    }
    export function getSegments(): Array<Type> {
        return ['B2B', 'B2C'];
    }
    export function getSelected(): Type {
        return (isPrivateCustomer()) ? 'B2C' : 'B2B';
    }
    export function toggle() {
        var current = ((cookieStore.get('PriceListKey')) ?? '') ?? 'B2B';

        if (current == 'B2B')
            setSegment('B2C')
        else if (current == 'B2C')
            setSegment('B2B')
    }
}
